import { useCallback } from 'react';

import { useHistory } from 'src/lib/hooks';

import { useSidebarEvents } from '../../service';

export const useHandlers = () => {
  const history = useHistory();
  const { trackNavigationItemClicked } = useSidebarEvents();

  const handleItemClick = useCallback(
    (linkItem) => {
      trackNavigationItemClicked({ label: linkItem.label });
      history.push(linkItem.path);
    },
    [trackNavigationItemClicked, history]
  );

  return {
    handleItemClick,
  };
};
